module.exports = __webpack_public_path__ + "img/05_uk.c6a7baf8.svg";